import { call, put, takeEvery } from "redux-saga/effects";
import { rateCardApi } from "services/RateCardService";
import { GET_RATECARD } from "resources/actionTypes";

function* fetchRateCard(action) {
  try {
    const payload = action.payload || {}
    const userRateCard = yield call(rateCardApi, payload);
    yield put({ type: GET_RATECARD.GET_RATECARD_SUCCESS, userRateCard: userRateCard });
  } catch (e) {
    yield put({ type: GET_RATECARD.GET_RATECARD_FAILED, message: e.message })
  }
}

export function* rateCardSaga() {
  yield takeEvery(GET_RATECARD.GET_RATECARD_REQUESTED, fetchRateCard);
}